import { expandCollapseManager } from '@wix/chat-web';
import { loadingScheduler } from '../loading-scheduler';
import wix from '../wix';
import { lazilyLoadFirebase, loadFirebase } from './firebase-loader';

const FIREBASE_POLLING_MAX_DELAY = 5000;
const FIREBASE_POLLING_INTERVAL = 2500;

export const triggerInteractivity = () =>
  void loadingScheduler
    .onConnective()
    .then(loadingScheduler.triggerInteractivity);

const loadLazily = (unpkgUrl: string, chatToken?: string) => {
  if (!chatToken) {
    void loadFirebase(unpkgUrl).then(loadingScheduler.triggerConnectivity);
  } else {
    void lazilyLoadFirebase(
      unpkgUrl,
      chatToken,
      FIREBASE_POLLING_MAX_DELAY,
      FIREBASE_POLLING_INTERVAL,
    ).then(loadingScheduler.triggerConnectivity);
  }

  const triggerInteractivityHandler = () => {
    void loadFirebase(unpkgUrl).then(loadingScheduler.triggerConnectivity);
    triggerInteractivity();

    window.removeEventListener('mouseover', triggerInteractivityHandler);
    expandCollapseManager.unregisterOnExpand(triggerInteractivityHandler);
  };

  window.addEventListener('mouseover', triggerInteractivityHandler);
  expandCollapseManager.registerOnExpand(triggerInteractivityHandler);
  window.setTimeout(triggerInteractivityHandler, FIREBASE_POLLING_MAX_DELAY);
  wix.registerQab(triggerInteractivityHandler);
};

const loadRegularly = () => {
  loadingScheduler.triggerConnectivity();

  if (window.requestIdleCallback) {
    window.requestIdleCallback(triggerInteractivity);
  }
  wix.onReady(triggerInteractivity);
};

export const loadChat = ({ widgetMode, unpkgUrl, chatToken }) => {
  const isSiteMode = widgetMode === 'site';

  if (isSiteMode) {
    loadLazily(unpkgUrl, chatToken);
  } else {
    loadRegularly();
  }
};
